import Vue from 'vue'
import Router from 'vue-router'
import data2 from '../views/data2.vue'
import Default from '../views/index.vue'
import details from '../views/details.vue'
import data3 from '../views/data3.vue'
import data4 from '../views/data4.vue'

Vue.use(Router)

export default new Router({
  routes: [{
  	path: '/',
  	component: Default
  }, {
  	path: '/data2',
  	component: data2
  }, {
  	path: '/details/:id',
  	component: details
  }, {
  	path: '/data3',
  	component: data3
  }, {
  	path: '/data4',
  	component: data4
  }]
})